var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRLogo = function SvgRLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125.8 138.9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17",
    d: "M67.883.229a39.693 39.693 0 0 1 14.142 75.484c3.922 6.075 22.913 35.347 35.749 55.147H0V0h61.962a48.44 48.44 0 0 1 5.921.229Z",
    transform: "translate(4 4)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: 1,
      fill: "#157eff",
      stroke: "#157eff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19",
    d: "M117.806 103.443H0L58.494 12.07Z",
    transform: "translate(4 31.416)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: 1,
      fill: "#00bdff",
      stroke: "#00bdff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20",
    d: "M0 75.735V0h32.878l49.138 75.7Z",
    transform: "translate(4 4)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: 1,
      fill: "#1560fa",
      stroke: "#1560fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21",
    d: "M10.79 48.318 33.985 12.07l23.522 36.248Z",
    transform: "translate(28.509 31.416)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: 1,
      fill: "#00efe9",
      stroke: "#00efe9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22",
    d: "M77.192 103.443H33.42L17.88 12.07Z",
    transform: "translate(44.614 31.416)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: 1,
      fill: "rgba(21,126,255,.5)"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRLogo);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjUuOCAxMzguOSI+PHBhdGggZGF0YS1uYW1lPSJQYXRoIDE3IiBkPSJNNjcuODgzLjIyOWEzOS42OTMgMzkuNjkzIDAgMCAxIDE0LjE0MiA3NS40ODRjMy45MjIgNi4wNzUgMjIuOTEzIDM1LjM0NyAzNS43NDkgNTUuMTQ3SDBWMGg2MS45NjJhNDguNDQgNDguNDQgMCAwIDEgNS45MjEuMjI5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNCA0KSIgc3R5bGU9InN0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDoxcHg7ZmlsbDojMTU3ZWZmO3N0cm9rZTojMTU3ZWZmIi8+PHBhdGggZGF0YS1uYW1lPSJQYXRoIDE5IiBkPSJNMTE3LjgwNiAxMDMuNDQzSDBMNTguNDk0IDEyLjA3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNCAzMS40MTYpIiBzdHlsZT0ic3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjFweDtmaWxsOiMwMGJkZmY7c3Ryb2tlOiMwMGJkZmYiLz48cGF0aCBkYXRhLW5hbWU9IlBhdGggMjAiIGQ9Ik0wIDc1LjczNVYwaDMyLjg3OGw0OS4xMzggNzUuN1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQgNCkiIHN0eWxlPSJzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6MXB4O2ZpbGw6IzE1NjBmYTtzdHJva2U6IzE1NjBmYSIvPjxwYXRoIGRhdGEtbmFtZT0iUGF0aCAyMSIgZD0iTTEwLjc5IDQ4LjMxOCAzMy45ODUgMTIuMDdsMjMuNTIyIDM2LjI0OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI4LjUwOSAzMS40MTYpIiBzdHlsZT0ic3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjFweDtmaWxsOiMwMGVmZTk7c3Ryb2tlOiMwMGVmZTkiLz48cGF0aCBkYXRhLW5hbWU9IlBhdGggMjIiIGQ9Ik03Ny4xOTIgMTAzLjQ0M0gzMy40MkwxNy44OCAxMi4wN1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ0LjYxNCAzMS40MTYpIiBzdHlsZT0ic3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjFweDtmaWxsOnJnYmEoMjEsMTI2LDI1NSwuNSkiLz48L3N2Zz4=";